import { Component, OnInit, Input, HostListener } from '@angular/core';

@Component({
  selector: 'app-header-two',
  templateUrl: './header-two.component.html',
  styleUrls: ['./header-two.component.scss']
})
export class HeaderTwoComponent implements OnInit {

  @Input() class: string;
  // @Input() themeLogo: string = 'https://izzimoviles.s3.us-east-1.amazonaws.com/Imagenes/GIGMAX_WHITE.png'; //'assets/images/icon/logo_bt_white.png'; // Default Logo
  @Input() themeLogo: string = 'assets/images/icon/logo_gigmax.webp'; // Default Logo
  @Input() topbar: boolean = true; // Default True
  @Input() sticky: boolean = false; // Default false
  
  public stick: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  // @HostListener Decorator
  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (number >= 150 && window.innerWidth > 400) { 
      this.stick = true;
    } else {
      this.stick = false;
    }
  }

}
